const formatTimeDisplay = (date: Date) => {
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

export const getTimeDisplay = (startTime: Date, endTime: Date) => {
  return `${formatTimeDisplay(startTime)} - ${formatTimeDisplay(endTime)}`;
};
